import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChevronDoubleDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chevron-double-down"><g id="Icon"><path d="M12.6365 12.0864C12.285 12.4379 11.7152 12.4379 11.3637 12.0864L7.8637 8.58644C7.51223 8.23497 7.51223 7.66512 7.8637 7.31365C8.21517 6.96218 8.78502 6.96218 9.13649 7.31365L12.0001 10.1773L14.8637 7.31365C15.2152 6.96218 15.785 6.96218 16.1365 7.31365C16.488 7.66513 16.488 8.23497 16.1365 8.58645L12.6365 12.0864Z" fill="currentColor" /><path d="M12.6365 17.0864C12.285 17.4379 11.7152 17.4379 11.3637 17.0864L7.8637 13.5864C7.51223 13.235 7.51223 12.6651 7.8637 12.3137C8.21517 11.9622 8.78502 11.9622 9.13649 12.3137L12.0001 15.1773L14.8637 12.3137C15.2152 11.9622 15.785 11.9622 16.1365 12.3137C16.488 12.6651 16.488 13.235 16.1365 13.5864L12.6365 17.0864Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChevronDoubleDownIcon;